import {
  Show,
  SimpleShowLayout,
  TextField,
  EmailField,
  DateField,
} from 'react-admin';
import ClickableImageField from '../fields/ClickableImageField';

export const UserItem = (props) => (
    <Show {...props}>
      <SimpleShowLayout>
        <TextField source="id" />
        <ClickableImageField source="avatar" />
        <TextField source="name" />
        <TextField source="language" />
        <TextField source="sex" />
        <TextField source="username" />
        <EmailField source="email" />
        <DateField source="created_at" />
      </SimpleShowLayout>
    </Show>
);
